import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EmployerSidebar from './EmployerSidebar'
import EmployerLetsStart from './EmployerLetsStart'
import RecentlyJoined from './RecentlyJoined'
import EmployerOverview from './EmployerOverview'
import EmployerTestimonial from './EmployerTestimonial'
import CandidateSideBar from '../Candidate/Profile/CandidateSideBar'
import CoachSideBar from '../Coach/Profile/CoachSideBar'
import { getUserInformation, getUsersByProfile } from '../../actions/userAuth'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../Navbar'
import { useNavigate } from 'react-router-dom'
import Layout from '../../assets/Layout'
import UserLayout from '../../assets/UserLayout'
import EmployerChart from './EmployerChart'


export default function EmployerDashboard() {
  const { user } = useSelector((state) => ({ ...state }));
  const [candidates, setCandidates] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      navigate('/')
    }
  }, [])

  useEffect(() => {
    dispatch(getUsersByProfile({role: 'CANDIDATE'}, (data) => {
      setCandidates(data.data.data);
    }))
  },[])

  return (
    <>
      <Layout>
        <UserLayout userRole={"employer"}>
          <Box px={4}>
            <EmployerChart />
          </Box>
          <Box px={4}>
            <EmployerLetsStart />
          </Box>
          <Box px={4}>
            <EmployerTestimonial />
          </Box>
          <Box px={4}>
            <RecentlyJoined candidates={candidates}/>
          </Box>
          <Box px={4}>
            <EmployerOverview />
          </Box>
        </UserLayout>
      </Layout>
    </>
  )
}
